import * as React from "react";
import APIClient from "web_modules/APIClient";
import MortgageDefinitions from "web_modules/shared/mortgage_definitions";
import { BorrowerInfo, BorrowerQualification, Header, TransactionDetails } from "./components";

const styles = require("./styles.module.scss");

interface AppViewProps {
  match: {
    params: { appID: number };
  };
}

class AppView extends React.Component<AppViewProps, { definitions: MortgageDefinitions }> {
  state = {
    definitions: null,
  };

  componentDidMount() {
    const {
      match: {
        params: { appID },
      },
    } = this.props;
    APIClient.get(`/uw/${appID}/mortgage_definitions`).then(({ definitions }) => {
      this.setState({ definitions });
    });
  }

  render() {
    const {
      match: {
        params: { appID },
      },
    } = this.props;
    const { definitions } = this.state;
    if (!definitions) {
      return <div />;
    }

    const {
      LoanStatus,
      ExternalLoanId,
      Borrower1,
      Borrower2,
      Borrower1CreditScores,
      Borrower2CreditScores,
      PurchasedPropertyAddress,
      PurchasedPropertyUsage,
      PurchasedPropertyType,
      ClosingDate,
      LoanAmount,
      PurchasePrice,
      LTV,
      NoteRate,
      RateLockedAt,
      LoanProgram,
      DebtToIncomeRatio,
      MonthlyIncome,
      QualifyingMonthlyDebt,
      EstimatedTotalAssetsRequired,
      EstimatedClosingCosts,
      EstimatedMinimumReservesRequired,
      VerifiedAssetsTotal,
    } = definitions as MortgageDefinitions;

    return (
      <div className={styles.container}>
        <Header
          externalLoanId={ExternalLoanId || "Not set"}
          borrower1FullName={Borrower1.FullName}
          borrower2FullName={Borrower2 && Borrower2.FullName}
          property={PurchasedPropertyAddress}
          loanStatus={LoanStatus || "–"}
        />
        <BorrowerInfo
          borrower1={Borrower1}
          borrower2={Borrower2}
          borrower1CreditScores={Borrower1CreditScores}
          borrower2CreditScores={Borrower2CreditScores}
        />
        <TransactionDetails
          loanPurpose={"Purchase"}
          occupancy={PurchasedPropertyUsage}
          propertyType={PurchasedPropertyType}
          closingDate={ClosingDate}
          loanAmount={LoanAmount}
          purchasePrice={PurchasePrice}
          LTV={LTV}
          interestRate={NoteRate}
          lockTime={RateLockedAt}
          loanProduct={LoanProgram}
          loanTerm={"30 Year"}
          property={PurchasedPropertyAddress}
          appID={appID}
          estimatedTotalAssetsRequired={EstimatedTotalAssetsRequired}
          estimatedClosingCosts={EstimatedClosingCosts}
          estimatedReservesRequired={EstimatedMinimumReservesRequired}
        />
        {/*TODO(pratik): fill out with info from mortgage definitions*/}
        <BorrowerQualification
          monthlyIncomeTotal={MonthlyIncome}
          monthlyDebtTotal={QualifyingMonthlyDebt}
          DTI={DebtToIncomeRatio}
          assetsTotal={VerifiedAssetsTotal}
          appID={appID}
        />
      </div>
    );
  }
}

export default AppView;
